import {
  DocumentTypeAttributes,
  DocumentTypeEnum,
} from "../attributes/document-type-attributes";

class DocumentType {
  code: DocumentTypeEnum;

  constructor(code: DocumentTypeEnum) {
    this.code = code;
  }

  static fromJson(json: DocumentTypeAttributes): DocumentType {
    if (json === null || json === undefined) {
      return null;
    }

    return new DocumentType(json.code);
  }

  display(): string {
    switch (this.code) {
      case DocumentTypeEnum.cni:
        return "sharedScreen.nationalIdentityCard";
      case DocumentTypeEnum.passport:
        return "sharedScreen.passport";
      case DocumentTypeEnum.trade_registry:
        return "sharedScreen.tradeRegistry";
      case DocumentTypeEnum.tax_payer_ard:
        return "sharedScreen.taxPayer";
      case DocumentTypeEnum.id_bank_account:
        return "sharedScreen.idBankAccountDoc";
    }

    return "";
  }
}

export default DocumentType;
